<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="50rem"
    :persistent="loading === true"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip left>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{ ...dialog, ...tooltip }">
            <v-icon>fa-history</v-icon>
          </v-btn>
        </template>
        Historique local des saisies d'inventaire
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row
          dense
          no-gutters
          align="start"
          justify="space-between"
          style="flex-wrap: nowrap;"
        >
          <span class="overline pa-3"
            >Historique local des saisies d'inventaire</span
          >
          <v-btn
            small
            icon
            text
            @click="dialog = !dialog"
            :disabled="loading === true"
          >
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="mb-3" v-show="loading === true">
          <v-progress-linear indeterminate></v-progress-linear>
        </v-row>
        <v-data-table
          dense
          :items-per-page="10"
          :items="
            getInventoryRecordsHistory.filter(x => x.store === getStoreId)
          "
          :headers="headers"
          sort-by="date"
          :sort-desc="true"
          :mobile-breakpoint="0"
          :hide-default-header="$vuetify.breakpoint.xsOnly"
        >
          <template v-slot:item.name="{ item }">
            <span class="caption font-capitalize">{{ getName(item) }}</span>
          </template>
          <template v-slot:item.date="{ item }">
            <span class="caption">{{ item.date | localFormat }}</span>
          </template>
          <template v-slot:item.updated="{ item }">
            <span class="caption">{{ item.updated | localFormat }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-row align="center" justify="end" no-gutters>
              <v-btn
                icon
                small
                @click="retry(item)"
                :disabled="loading === true"
              >
                <v-icon small>fa-redo</v-icon>
              </v-btn>
            </v-row>
          </template>
          <template v-slot:item.mobile="{ item }">
            <div class="my-1" style="width: 200px">
              <v-row align="center" justify="start" no-gutters class="mb-1">
                <span class="font-capitalize caption font-weight-medium">
                  {{ getName(item) }}</span
                >
              </v-row>
              <v-row align="center" justify="start" no-gutters>
                <span class="caption font-weight-medium mr-2">Créé</span>
                <span class="caption">{{ item.date | localFormat }}</span>
              </v-row>
              <v-row align="center" justify="start" no-gutters>
                <span class="caption font-weight-medium mr-2">Essai</span>
                <span class="caption">{{ item.updated | localFormat }}</span>
              </v-row>
            </div>
          </template>
        </v-data-table>
        <v-form v-model="retryValid" @submit.prevent="">
          <v-row align="center" justify="start" no-gutters>
            <Prompt
              type="confirm"
              color="primary"
              :inputText="
                `Êtes-vous certain de vouloir effectuer à nouveau toutes les transactions enregistrées depuis ${timeTreshold} heure${
                  timeTreshold > 1 ? 's' : ''
                } ?`
              "
              submitText="Oui"
              activator-icon="fa-redo"
              activator-text="Refaire les transactions depuis"
              :disabled="retryValid === false || loading === true"
              @submit="retryFrom"
            ></Prompt>
            <div class="medium-input" style="width: 130px">
              <j-decimal-input
                dense
                filled
                hide-details
                class="no-before"
                v-model="timeTreshold"
                suffix="heures"
                :min="1"
                :step="1"
                :decimal="0"
                :disabled="loading === true"
              ></j-decimal-input>
            </div>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "InventoryRecordLocalHistory",
  computed: {
    ...mapGetters(["getInventoryRecordsHistory", "getProducts", "getStoreId"]),
    headers() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return [
          { value: "name", text: "Produit" },
          { value: "quantity", text: "Quantité" },
          { value: "date", text: "Date" },
          { value: "updated", text: "Dernier essai" },
          { value: "actions", text: "" }
        ];
      } else {
        return [{ value: "mobile" }, { value: "actions" }];
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      timeTreshold: 1,
      retryValid: true
    };
  },
  methods: {
    getName(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      return p ? p.nom : "";
    },
    async retry(item) {
      try {
        this.loading = true;
        item.updated = moment().toDate();
        const res = await api.postInventoryRecordNormalHandler(item);
        this.$store.dispatch("updateInventoryRecord", res);
      } finally {
        this.loading = false;
      }
    },
    async retryFrom(confirm) {
      if (confirm === true) {
        try {
          this.loading = true;
          const treshold = moment().subtract(this.timeTreshold, "h");
          const transactions = this.getInventoryRecordsHistory.filter(x =>
            moment(x.date).isSameOrAfter(treshold)
          );
          for (let transaction of transactions) {
            transaction.updated = moment().toDate();
            const res = await api.postInventoryRecordNormalHandler(transaction);
            this.$store.dispatch("updateInventoryRecord", res);
          }
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
